import * as React from "react";
import { FC } from "react";
import { WelcomeEntryPoint } from "../../entrypoints/welcome";
import { LANG } from "../../common/types/localization";

export default (): FC => <WelcomeEntryPoint lang={LANG.plPL} />;
